export default "__VITE_ASSET__3f39c2b0__"